export default __webpack_public_path__ + "images/aed4540d20c71449972db8113ee3f70e.png";